import { render, staticRenderFns } from "./footer-info.vue?vue&type=template&id=1ece1bc7&scoped=true&"
import script from "./footer-info.vue?vue&type=script&lang=js&"
export * from "./footer-info.vue?vue&type=script&lang=js&"
import style0 from "./footer-info.vue?vue&type=style&index=0&id=1ece1bc7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ece1bc7",
  null
  
)

export default component.exports